<template>
  <div class="breadcrumbs">
    <ol class="breadcrumbs__container" itemscope itemtype="http://schema.org/BreadcrumbList">
      <slot></slot>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
}
</script>
<style lang="scss" scoped>
.breadcrumbs {
  &__container {
    display: flex;
    align-items: center;
  }
}
</style>
